<template>
    <section class="uxo-item" v-if="incident">
        <template v-if="!fetchingIncident">
            <template v-if="incident.name">
                <h1 class="mb-2">{{ incident.name }}</h1>
                <div class="d-flex flex-column flex-lg-row mb-7">
                    <div class="uxo-item__gallery mb-4 mr-md-3">
                        <template v-if="user">
                            <cat-uxo-carousel class="mb-3"
                                              v-if="(user.eod_technician || user.technical_interest) && incident.images.length > 1"
                                              :starting-image="0"
                                              :slides="images"
                            ></cat-uxo-carousel>
                            <img v-else  class="image w-auto align-self-center mb-3"
                                 :src="incident.images[0].aws_url" :alt="incident.name"/>
                        </template>
                        <template v-else>
                            <img v-if="incident.images[0]" class="image w-auto align-self-center mb-3"
                                 :src="incident.images[0].aws_url" :alt="incident.name"/>
                        </template>


                        <cat-uxo-contribute
                            :contribution-type="5"
                            :contribution-model="incident"
                            v-if="user && (user.eod_technician || user.technical_interest)" :user="user"
                                            :button="'Contribute Information'"></cat-uxo-contribute>
                        <a v-else href="/sign-up" class="btn w-100">Sign Up</a>

                    </div>
                    <div class="uxo-item__content">
                        <h2 class="font-weight-normal uxo-item__section-heading">Description</h2>
                        <div class="rich-content" v-html="incident.description_html"></div>
                    </div>
                </div>
                <div class="d-flex flex-column" v-if="user">

                    <div class="uxo-item__operation mb-3"
                         v-if="(user.eod_technician || user.technical_interest) && incident.further_information_html">
                        <div class="uxo-item__content uxo-item__content--full" v-if="incident.further_information_html">
                            <h3 class="uxo-item__section-heading">Further Information</h3>
                            <div class="rich-content" v-html="incident.further_information_html"></div>
                        </div>
                    </div>

                    <div class="uxo-item__operation mb-3" v-if="(user.eod_technician) && incident.analysis_html">
                        <div class="uxo-item__content uxo-item__content--full" v-if="incident.analysis_html">
                            <h3 class="uxo-item__section-heading">Analysis</h3>
                            <div class="rich-content" v-html="incident.analysis_html"></div>
                        </div>
                    </div>
                </div>

                <cat-uxo-supporter-contributions
                    :contribution-type="5"
                    :contribution-model="incident"
                    :user="user"
                    v-if="user && (user.eod_technician || user.technical_interest)"></cat-uxo-supporter-contributions>

                <cat-uxo-linear-ads class="mb-10"></cat-uxo-linear-ads>
                <div v-if="!user || (user && user.guest)" class="call-to-action-wrap">
                    <div class="d-sm-flex columns justify-content-between mb-8">
                        <div class="d-flex w-50 mr-sm-3 mb-3 mb-sm-0">
                            <cat-uxo-call-to-action class="d-flex h-100 shape--uxo-item"></cat-uxo-call-to-action>
                        </div>
                        <div class="d-flex w-50">
                            <cat-uxo-call-to-action-outline class="d-flex h-100"></cat-uxo-call-to-action-outline>
                        </div>
                    </div>
                </div>

                <div class="associated-associatedHazards mt-8" v-if="incident.related_hazards.length > 0">
                    <h2 class="t-orange text-center mb-3">Associated Hazards</h2>
                    <div class="uxo-list columns is-multiline is-mobile mb-5">
                        <template v-for="(associatedHazard) in incident.related_hazards">
                            <div class="column is-4-mobile is-2-tablet mb-1">
                                <a class="uxo-list__item" :href="associatedHazard.url">
                                    <img class="image mb-1" v-if="associatedHazard.images && associatedHazard.images[0]"
                                         :src="associatedHazard.images[0].aws_url"
                                         :alt="associatedHazard.name"/>
                                    <h5 class="font-weight-normal">{{ associatedHazard.name }}</h5>
                                </a>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="associated-associatedHazards mt-8" v-if="incident.terrorist_groups.length > 0">
                    <h2 class="t-orange text-center mb-3">Associated Terrorist Groups</h2>
                    <div class="uxo-list columns is-multiline is-mobile mb-5">
                        <template v-for="(associatedTerroristGroup) in incident.terrorist_groups">
                            <div class="column is-4-mobile is-2-tablet mb-1">
                                <a class="uxo-list__item"
                                   :href="`/explosive-hazards/terrorist-groups/${associatedTerroristGroup.slug}`">
                                    <img class="image border-radius mb-1"
                                         v-if="associatedTerroristGroup.images && associatedTerroristGroup.images[0]"
                                         :src="associatedTerroristGroup.images[0].aws_url"
                                         :alt="associatedTerroristGroup.name"/>
                                    <h5 class="font-weight-normal">{{ associatedTerroristGroup.name }}</h5>
                                </a>
                            </div>
                        </template>
                    </div>
                </div>

            </template>
            <template v-else>
                <h2>The Incident you are looking for could not be found.</h2>
            </template>
        </template>
        <template v-else>
            <div class="content-loader">
                <ContentLoader
                    :height="56"
                    :width="720"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="16" y="0" rx="5" ry="5" width="300" height="40"/>
                </ContentLoader>
                <ContentLoader
                    :height="352"
                    :width="720"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    class="mb-2"
                >
                    <rect x="16" y="0" rx="0" ry="0" width="300" height="300"/>
                    <rect x="340" y="0" rx="5" ry="5" width="200" height="20"/>
                    <rect x="340" y="56" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="72" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="88" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="104" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="136" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="152" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="168" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="184" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="200" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="216" rx="5" ry="5" width="380" height="6.4"/>
                    <rect x="340" y="232" rx="5" ry="5" width="380" height="6.4"/>
                </ContentLoader>
            </div>
        </template>
    </section>
</template>

<script>
import CatUxoContribute from '@/js/components/shared/Contribute';
import CatUxoCarousel from '@/js/components/shared/Carousel';
import {mapActions, mapState} from "vuex";
import {ContentLoader} from 'vue-content-loader';
import truncate from 'vue-truncate-collapsed';
import LinearAds from "../shared/LinearAds";

export default {
    name: 'CatUxoIncident',
    props: {
        user: {
            type: Object,
            required: false
        },
        slug: {
            type: String,
            required: true
        },
    },
    components: {
        CatUxoContribute,
        CatUxoCarousel,
        ContentLoader,
        truncate,
        LinearAds,
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('incidents', [
            'incident',
            'fetchingIncident'
        ]),
        images: function () {
            let urls = [];
            this.incident.images.forEach(function (image) {
                if (image.aws_url) {
                    urls.push(image.aws_url);
                }
            });

            return urls;
        }
    },
    methods: {
        ...mapActions('incidents', [
            'fetchIncident'
        ]),
    },
    created() {
        this.fetchIncident({slug: this.slug})
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>

.uxo-item__content {
    overflow: auto;
}

.uxo-item__eod-warning {
    background: $c-white;
    color: $c-orange;
    font-weight: normal;
    line-height: $lh-lg;
    font-size: $fs-18;
}

@include media-breakpoint-down(sm) {
    .call-to-action-wrap {
        .w-50 {
            width: 100% !important;
        }
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/Incident.vue